import * as React from 'react';

import {SectionLabel} from 'shells/typography/section-label';

import type {
    SessionUser as SessionUserFragment,
    Lead_stageset,
    LeadStagesEdge as LeadStagesEdgeFragment,
} from 'nutshell-graphql-types';

import {StageGoalCondition} from './stage-goal-condition';
import {StageGuidance} from './stage-guidance';

import styles from './stage-guidance-and-goals.module.css';

type Props = {
    user: SessionUserFragment | null | undefined;
    stageset: Lead_stageset;
    leadStageEdge: LeadStagesEdgeFragment;
};

export class StageGuidanceAndGoals extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['stage-guidance-and-goals-container']}>
                <SectionLabel>Goals: {this.props.leadStageEdge.node.name}</SectionLabel>
                <div className={styles['stage-guidance-and-goals']}>
                    <StageGuidance
                        user={this.props.user}
                        stageset={this.props.stageset}
                        leadStageEdge={this.props.leadStageEdge}
                    />
                    {NutCapabilities.SAGoals.isAvailable ? (
                        <div className={styles['goals-container']}>
                            {this.props.leadStageEdge.goalConditions.map((goalCondition) => {
                                return (
                                    <StageGoalCondition
                                        key={goalCondition.condition.id}
                                        goalCondition={goalCondition}
                                    />
                                );
                            })}
                        </div>
                    ) : undefined}
                </div>
            </div>
        );
    }
}
